// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3824":"a4fa4bff5ce97f29","4470":"6ca4588a313491c1","4721":"90034b9f90efc84c","6345":"6d72e602ed2b62d6"}[chunkId] + ".js";
};